import React, { FunctionComponent, ChangeEvent } from "react";
import { Choice, Alert } from "@cmsgov/ds-medicare-gov";
import { useTranslate } from "../../helpers";
import { FormattedMessage } from "react-intl";
import { CoverageType } from "./types";
import { choiceIdMap } from "./constants";

export const getCoverageTypeLabel = (
  coverageType: CoverageType
): string | undefined | null => {
  let description = undefined;
  if (coverageType) {
    const choiceId = choiceIdMap[coverageType];
    const labelKey = `label[for='${choiceId}']`;
    description = document.querySelector(labelKey)?.textContent;
  }
  return description;
};

interface PlanQuestionsProps {
  handleChoice: (e: ChangeEvent<HTMLInputElement>) => void;
  coverageSelection?: CoverageType;
}

// Modeled after src/pages/QuestionRoutingPage/PlanQuestions.tsx
// TODO: see if we can combine the two.
export const PlanQuestions: FunctionComponent<PlanQuestionsProps> = ({
  handleChoice,
  coverageSelection,
}) => {
  const t = useTranslate();

  const mapdSelected = coverageSelection === CoverageType.MAPD;
  const pdpSelected = coverageSelection === CoverageType.PDP;
  const medigapSelected = coverageSelection === CoverageType.MedigapPolicy;

  return (
    <>
      <Choice
        type="radio"
        name="what-coverage"
        id={choiceIdMap[CoverageType.MAPD]}
        data-testid={choiceIdMap[CoverageType.MAPD]}
        value={CoverageType.MAPD}
        onChange={handleChoice}
        checked={mapdSelected}
        checkedChildren={
          <Alert role="alert" hideIcon={true}>
            {t("landing_page.coverage_selection.mapd.text")}
          </Alert>
        }
        label={t("landing_page.coverage_selection.mapd.heading")}
      />

      <Choice
        type="radio"
        name="what-coverage"
        id={choiceIdMap[CoverageType.PDP]}
        data-testid={choiceIdMap[CoverageType.PDP]}
        value={CoverageType.PDP}
        onChange={handleChoice}
        checked={pdpSelected}
        checkedChildren={
          <Alert role="alert" hideIcon={true}>
            {t("landing_page.coverage_selection.pdp.text")}
          </Alert>
        }
        label={
          <FormattedMessage
            id="landing_page.coverage_selection.pdp.heading"
            tagName="span"
            values={{
              message: <span aria-label="Dee">D</span>,
            }}
          />
        }
      />

      <Choice
        type="radio"
        name="what-coverage"
        id={choiceIdMap[CoverageType.MedigapPolicy]}
        data-testid={choiceIdMap[CoverageType.MedigapPolicy]}
        value={CoverageType.MedigapPolicy}
        onChange={handleChoice}
        checked={medigapSelected}
        checkedChildren={
          <>
            <Alert role="alert" hideIcon={true}>
              {t("landing_page.coverage_selection.medigap.text")}
            </Alert>
          </>
        }
        label={t("landing_page.coverage_selection.medigap.heading")}
      />
      <Choice
        id={choiceIdMap[CoverageType.learnMore]}
        data-testid={choiceIdMap[CoverageType.learnMore]}
        type="radio"
        name="what-coverage"
        value={CoverageType.learnMore}
        onChange={handleChoice}
        label={t("landing_page.learn_more.heading")}
      />
    </>
  );
};
